import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import NProgress from 'nprogress'
import { getSavedState } from '@utils/auth'
import { Role } from '@/constants/role.js'
import { get } from 'lodash'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes,
})

const getUserRoles = () => {
    const user = getSavedState('auth.user')
    const roles = get(user, 'roles', [])

    return roles.reduce((roles, role) => ({ ...roles, [role]: true }), {})
}

const isUserRoleExist = (roles = {}) => Object.keys(roles).length !== 0

router.beforeEach((to, from, next) => {
    // If this isn't an initial page load...
    if (from.name !== null) {
        NProgress.start()
    }

    const { authorize } = to.meta
    const userRoles = getUserRoles()
    const isRoles = isUserRoleExist(userRoles)
    const isMandatoryRoleExist = authorize.some(authRole => userRoles[authRole])
    const authRequired = authorize && authorize.length > 0
    const isTokenExists = !!getSavedState('auth.boAuthToken')

    if (authRequired) {
        if (!isTokenExists || !isRoles || !isMandatoryRoleExist) {
            // not logged in so redirect to login page with the return url
            return next({ path: '/login', query: { returnUrl: to.path } })
        }

        // check if route is restricted by role
        if (authorize.length && !isMandatoryRoleExist) {
            // role not authorised so redirect to home page
            if (userRoles[Role.user]) {
                next({ name: 'user-main' })
            }

            return next()
        }
    }

    next()
})
router.afterEach(() => {
    NProgress.done()
})

export default router
